module.exports = __webpack_public_path__ + "img/kgold.025cecf.png";